import styled from 'styled-components';
import { hoverBlue } from '../../assets/ui/colors';

export const DefaultAuthContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const SupportContainer = styled.div`
  margin: 0 auto 50px auto;
  @media (max-width: 400px) {
    font-size: 15px;
    line-height: 21px;
  }
`;

export const SupportLink = styled.span`
  color: ${hoverBlue};
  cursor: pointer;
`;

export const WhatsappLink = styled.a`
  color: ${hoverBlue};
  cursor: pointer;
  margin-left: 4px;
`;

export const QrContainer = styled.div`
  margin-bottom: 15px;
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;
`;

export const QrText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  letter-spacing: 0.31px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  @media (max-width: 400px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const QrCodeContainer = styled.div`
  height: 80px;
  width: 80px;
  @media (max-width: 400px) {
    height: 65px;
    width: 65px;
  }
`;
